import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Radio, Spin, Divider } from 'antd';
//import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import {USER_SERVER} from '../../../config'
import Chat from './Chat';
import ShowResult from './ShowResult';
import NavBar from '../00_NavBar/NavBar';
import { v4 as uuidv4 } from 'uuid';

const { TextArea } = Input;

function LandingPage(props) {
    const [Reservations, setReservations] = useState([]);
    const [UserId, setUserId] = useState('');

    useEffect(() => {
        let userId = localStorage.getItem('tele_user_id');
        if (!userId) {
            userId = 'ts' + Date.now();
            localStorage.setItem('tele_user_id', userId);
        }
        setUserId(userId);
        console.log('UserId:', userId);

    }, []);

    return (
        <div>
            <Row>
                <Col span={14}>
                    <Chat setReservations={setReservations} UserId={UserId}/>
                </Col>
                <Col span={8}>
                    <ShowResult Reservations={Reservations}/>
                </Col>
            </Row>
        </div>
    )
}

export default LandingPage
